import { render, staticRenderFns } from "./AdminCreateComponent.vue?vue&type=template&id=cfbc8064&scoped=true&"
import script from "./AdminCreateComponent.vue?vue&type=script&lang=js&"
export * from "./AdminCreateComponent.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateComponent.vue?vue&type=style&index=0&id=cfbc8064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbc8064",
  null
  
)

export default component.exports